import { SetStateAction, Dispatch } from "react";

import { ValidationStatus } from "src/components/InputContainer";

export enum CoverOption {
  PHOTO = "PHOTO",
  VIDEO = "VIDEO",
  DEFAULT = "DEFAULT",
}

export interface CoverPhotoOrVideoPickerValidationErrors {
  coverYoutubeVideoUrl?: ValidationStatus;
  hasCoverOption?: ValidationStatus;
}

export interface CoverPhotoOrVideoPickerProps {
  defaultCoverImageId: string | null;

  coverImageAltText?: string;
  setCoverImageAltText: Dispatch<SetStateAction<string | undefined>>;

  validationErrors?: CoverPhotoOrVideoPickerValidationErrors;
  setValidationErrors: Dispatch<
    SetStateAction<CoverPhotoOrVideoPickerValidationErrors | undefined>
  >;

  coverYoutubeVideoId?: string | null;
  setCoverYoutubeVideoId: Dispatch<SetStateAction<string | null | undefined>>;

  coverImageId: string | null;
  setCoverImageId: Dispatch<SetStateAction<string | null>>;

  allowDefaultCoverImage: boolean;
}
